/**
 * 首页 · 全球分布（/index）字段模型
 * 后台按区块分组展示可编辑字段（中文 label + 类型 + 默认值），前端用 $C(scope, key, default) 读取。
 */
export default {
  title: '首页 · 全球分布',
  groups: [
    {
      title: '首页导航链接',
      fields: [
        { key: 'linkInternational', label: '国际市场链接文字', type: 'text', default: '国际市场' },
        { key: 'linkChina', label: '国内市场链接文字', type: 'text', default: '国内市场' },
        { key: 'linkGanzi', label: '甘孜市场链接文字', type: 'text', default: '甘孜市场' },
      ],
    },
    {
      title: '图片与视频',
      fields: [
        { key: 'pageBg', label: '页面背景图（覆盖默认背景）', type: 'image', default: '' },
      ],
    },
  ],
}
